import React from "react";
import { Card, CardBody } from "reactstrap";
import applicant from "../../../../assets/images/applicant.png";
import coapplicant from "../../../../assets/images/coapplicant.png";
export default function IncomeAndCibil(props) {
  const { applicationDetails, bankSelfieData, isExpanded, setIsExpanded } =
    props;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "30px",
      }}
    >
      <Card
        style={{
          border: "solid",
          borderRadius: "10px",
          borderWidth: "1px",
          borderColor: "#DBDBDB",
          width: "100%",
          height: "auto",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div style={{ marginTop: "10px" }}>
          <div
            style={{
              marginLeft: "20px",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              height: "40px",
            }}
          >
            <img
              style={{ height: "33px", width: "33px" }}
              src={applicant}
              alt="applicant"
            />
            <p
              style={{
                marginLeft: "20px",
                fontFamily: "Inter-Medium",
                color: "#232323",
                marginTop: "13px",
              }}
            >
              Applicant
            </p>
          </div>
          <div
            style={{
              borderTop: "0.75px solid #DBDBDB",
              margin: "10px 0",
            }}
          ></div>
        </div>
        <div style={{ paddingLeft: "20px" }}>
          <CardBody>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gridColumnGap: "20px",
              }}
            >
              <div style={{ width: "220px", height: "60px" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    CIBIL{" "}
                  </strong>
                  <span
                    style={{
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.score
                      ? applicationDetails.profile.cibilDetails.score
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "220px", height: "60px" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Average Daily Income
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData?.accountDetails?.averageBalance ||
                      "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "220px",
                  height: "60px",
                  marginTop: "10px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Monthly Income
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData?.accountDetails?.income || "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "220px",
                  height: "60px",
                  marginTop: "10px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Current Balance
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.currentBalance
                      ? applicationDetails.profile.cibilDetails.currentBalance
                      : "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "220px",
                  height: "60px",
                  marginTop: "10px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Current EMIs
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.currentEmis
                      ? applicationDetails.profile.cibilDetails.currentEmis
                      : "-------"}
                  </span>
                </p>
              </div>
              <div
                style={{
                  width: "220px",
                  height: "60px",
                  marginTop: "10px",
                }}
              >
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "20px",
                      fontSize: "15px",
                    }}
                  >
                    Overdue{" "}
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.overdues
                      ? applicationDetails.profile.cibilDetails.overdues
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "220px", marginTop: "10px" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    Write Offs
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.writeOffs
                      ? applicationDetails.profile.cibilDetails.writeOffs
                      : "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "220px", marginTop: "10px" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    FOIR(%)
                  </strong>

                  <span
                    style={{
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: "30px",
                    }}
                  >
                    {bankSelfieData?.accountDetails?.foir || "-------"}
                  </span>
                </p>
              </div>
              <div style={{ width: "220px", marginTop: "10px" }}>
                <p style={{ display: "flex", flexDirection: "column" }}>
                  <strong
                    style={{
                      color: "gray",
                      fontFamily: "Inter-Medium",
                      fontWeight: "400",
                      lineHeight: "10px",
                      fontSize: "15px",
                    }}
                  >
                    Delinquencies
                  </strong>

                  <span
                    onClick={() => setIsExpanded(!isExpanded)}
                    title={
                      applicationDetails?.coapplicantProfile?.userDetails
                        ?.name || ""
                    }
                    style={{
                      whiteSpace: isExpanded ? "normal" : "nowrap",
                      textOverflow: isExpanded ? "unset" : "ellipsis",
                      overflow: isExpanded ? "unset" : "hidden",
                      cursor: isExpanded ? "auto" : "pointer",
                      textDecoration: "none",
                      color: "#232323",
                      fontSize: "13px",
                      fontFamily: "Inter-Medium",
                      lineHeight: isExpanded ? "15px" : "30px",
                      display: "block",
                      width: "100%",
                      wordBreak: "break-word",
                    }}
                  >
                    {applicationDetails &&
                    applicationDetails.profile &&
                    applicationDetails.profile.cibilDetails &&
                    applicationDetails.profile.cibilDetails.deliquencies
                      ? applicationDetails.profile.cibilDetails.deliquencies
                      : "-------"}
                  </span>
                </p>
              </div>
            </div>
          </CardBody>
        </div>
      </Card>
      {applicationDetails ? (
        applicationDetails.coapplicantProfile ? (
          <Card
            style={{
              border: "solid",
              borderRadius: "10px",
              borderWidth: "1px",
              borderColor: "#DBDBDB",
              width: "100%",
              height: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div style={{ marginTop: "10px" }}>
              <div
                style={{
                  marginLeft: "20px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  height: "40px",
                }}
              >
                <img
                  style={{ height: "33px", width: "33px" }}
                  src={coapplicant}
                  alt="coapplicant"
                />
                <p
                  style={{
                    marginLeft: "20px",
                    fontFamily: "Inter-Medium",
                    color: "#232323",
                    marginTop: "13px",
                  }}
                >
                  Co-Applicant
                </p>
              </div>
              <div
                style={{
                  borderTop: "0.75px solid #DBDBDB",
                  margin: "10px 0",
                }}
              ></div>
            </div>
            <div style={{ paddingLeft: "20px" }}>
              <CardBody>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gridColumnGap: "0px",
                  }}
                >
                  <div style={{ width: "220px", height: "60px" }}>
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "20px",
                          fontSize: "15px",
                        }}
                      >
                        CIBIL
                      </strong>

                      <span
                        span
                        onClick={(event) => {
                          event.target.style.whiteSpace = "normal";
                          event.target.style.overflow = "visible";
                          event.target.style.cursor = "text";
                        }}
                        style={{
                          width: "10em",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          cursor: "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails.score
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .score
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div style={{ width: "220px", height: "60px" }}>
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Average Daily Income
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData?.accountDetails?.averageBalance ||
                          "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Monthly Income{" "}
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData?.accountDetails?.income || "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        {" "}
                        Current Balance
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails
                          .currentBalance
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .currentBalance
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Current EMIs
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails
                          .currentEmis
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .currentEmis
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Overdue{" "}
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails
                          .overdues
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .overdues
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Write Offs
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails
                          .writeOffs
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .writeOffs
                          : "-------"}
                      </span>
                    </p>
                  </div>
                  <div
                    style={{
                      width: "220px",
                      height: "60px",
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        FOIR(%)
                      </strong>

                      <span
                        style={{
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: "30px",
                        }}
                      >
                        {bankSelfieData?.accountDetails?.foir || "-------"}{" "}
                      </span>
                    </p>
                  </div>
                  <div style={{ width: "220px", marginTop: "10px" }}>
                    <p
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <strong
                        style={{
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontWeight: "400",
                          lineHeight: "10px",
                          fontSize: "15px",
                        }}
                      >
                        Delinquencies
                      </strong>

                      <span
                        onClick={() => setIsExpanded(!isExpanded)}
                        title={
                          applicationDetails?.coapplicantProfile?.userDetails
                            ?.name || ""
                        }
                        style={{
                          whiteSpace: isExpanded ? "normal" : "nowrap",
                          textOverflow: isExpanded ? "unset" : "ellipsis",
                          overflow: isExpanded ? "unset" : "hidden",
                          cursor: isExpanded ? "auto" : "pointer",
                          textDecoration: "none",
                          color: "#232323",
                          fontSize: "13px",
                          fontFamily: "Inter-Medium",
                          lineHeight: isExpanded ? "15px" : "30px",
                          display: "block",
                          width: "100%",
                          wordBreak: "break-word",
                        }}
                      >
                        {applicationDetails &&
                        applicationDetails.coapplicantProfile &&
                        applicationDetails.coapplicantProfile.cibilDetails &&
                        applicationDetails.coapplicantProfile.cibilDetails
                          .deliquencies
                          ? applicationDetails.coapplicantProfile.cibilDetails
                              .deliquencies
                          : "-------"}
                      </span>
                    </p>
                  </div>
                </div>
              </CardBody>
            </div>
          </Card>
        ) : null
      ) : null}
    </div>
  );
}
